import icon from '@plone/volto/icons/quote.svg';
import BlockEdit from './Edit';
import BlockView from './View';
import './theme/_main.scss';
export default function installBlockQuote(config) {
  config.blocks.blocksConfig.blockquote = {
    id: 'blockquote',
    title: 'Block Quote',
    edit: BlockEdit,
    view: BlockView,
    icon: icon,
    group: 'text',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };
  return config;
}
